module.exports = __webpack_public_path__ + "static/media/logo_montessori.44aa70f5.png";